import { render, staticRenderFns } from "./ProductItemVariantMove.vue?vue&type=template&id=4c30cb92&"
import script from "./ProductItemVariantMove.vue?vue&type=script&lang=js&"
export * from "./ProductItemVariantMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports